import { countSelectedByItem, getRowStockState } from '../claim-product/func/stockHelper';

export const APPROVAL_STOCK_ALL = 'ALL';

// คำขออนุมัติเป็นความต้องการส่งใหม่ แม้เคลมต้นทางของคำขอส่งซ้ำจะจัดส่งแล้ว
export const approvalStockRecord = (record) => ({ ...record, processStatus: '' });

export const countApprovalSelectedByItem = (rows, selectedKeys, rowKey = 'claimId') =>
  countSelectedByItem((rows ?? []).map(approvalStockRecord), selectedKeys, rowKey);

export const getApprovalStockState = (record, stockMap, selectedByItem) =>
  getRowStockState({ record: approvalStockRecord(record), stockMap, selectedByItem });

export const filterApprovalRowsByStock = (rows, stockStatus, stockMap, selectedByItem) => {
  if (stockStatus === APPROVAL_STOCK_ALL) return rows;
  return (rows ?? []).filter(
    (record) => getApprovalStockState(record, stockMap, selectedByItem).state === stockStatus,
  );
};
